/* Rewind Fit Quiz - in-house replacement for the Easysize "Fit Quiz" app.
   Six questions, one recommendation, no third-party requests.
   Reads its data from <script type="application/json" data-rw-fit-quiz> next to the trigger. */
(function () {
  'use strict';
  if (window.RwFitQuiz) return;

  var ICON = {
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12"/><path d="M18 6L6 18"/></svg>'
  };

  /* Side-profile torso, three belly shapes. */
  function bellyFigure(kind) {
    /* Side view facing right: head, back line, chest-to-belly front line (varies), arm hanging in front, dashed hint. */
    var front = { flat: 'M52 34 C53 46, 53 62, 50 78', average: 'M52 34 C57 46, 58 64, 51 78', round: 'M52 34 C63 46, 65 66, 52 78' }[kind];
    var dash = { flat: 'M58 40 C59 52, 58 66, 55 80', average: 'M58 40 C64 52, 64 68, 56 80', round: 'M58 40 C71 52, 72 70, 57 80' }[kind];
    return '<svg viewBox="0 0 80 104" aria-hidden="true">' +
      '<path d="M40 4 C50 2, 58 9, 56 18 C55 25, 48 29, 42 26 C36 23, 33 15, 36 9 C37 7, 38 5, 40 4 Z"/>' +
      '<path d="M42 26 C40 30, 36 33, 33 38 C28 46, 27 60, 28 78 C29 88, 30 96, 30 104"/>' +
      '<path d="M50 27 C51 30, 52 32, 52 34"/>' +
      '<path d="' + front + '"/>' +
      '<path d="M50 78 C52 88, 52 96, 52 104"/>' +
      '<path d="M37 40 C33 48, 32 58, 33 68 C34 76, 36 82, 38 86 C39 88, 41 88, 41 85 C41 80, 40 74, 39 68"/>' +
      '<path d="M30 78 C34 80, 42 80, 50 78"/>' +
      '<path class="rw-fq-dash" d="' + dash + '"/>' +
      '</svg>';
  }

  /* Front torso, three chest widths. */
  function chestFigure(kind) {
    var w = { slim: 14, average: 18, broad: 23 }[kind];
    var L = 40 - w, R = 40 + w;
    return '<svg viewBox="0 0 80 104" aria-hidden="true">' +
      '<path d="M32 10 H48 L46 22 H34 Z"/>' +
      '<path d="M34 22 C22 26, ' + (L - 6) + ' 30, ' + (L - 8) + ' 40 C' + (L - 9) + ' 56, ' + (L - 6) + ' 72, ' + (L - 4) + ' 80"/>' +
      '<path d="M46 22 C58 26, ' + (R + 6) + ' 30, ' + (R + 8) + ' 40 C' + (R + 9) + ' 56, ' + (R + 6) + ' 72, ' + (R + 4) + ' 80"/>' +
      '<path class="rw-fq-shade" d="M' + (L + 2) + ' 36 C' + (L + 6) + ' 30, 36 30, 40 34 C44 30, ' + (R - 6) + ' 30, ' + (R - 2) + ' 36 L' + (R - 4) + ' 60 C' + (R - 8) + ' 64, ' + (L + 8) + ' 64, ' + (L + 4) + ' 60 Z"/>' +
      '<path d="M' + (L + 4) + ' 36 C' + (L + 8) + ' 42, ' + (L + 10) + ' 56, ' + (L + 8) + ' 80 M' + (R - 4) + ' 36 C' + (R - 8) + ' 42, ' + (R - 10) + ' 56, ' + (R - 8) + ' 80"/>' +
      '<path d="M' + (L + 8) + ' 80 H' + (R - 8) + '"/>' +
      '<path class="rw-fq-dash" d="M' + (L - 8) + ' 40 C' + (L - 4) + ' 32, 30 26, 34 22 M' + (R + 8) + ' 40 C' + (R + 4) + ' 32, 50 26, 46 22"/>' +
      '</svg>';
  }

  /* Front lower body, three hip widths (for bottoms). */
  function hipsFigure(kind) {
    var w = { slim: 13, average: 16, wide: 20 }[kind];
    var L = 40 - w, R = 40 + w;
    return '<svg viewBox="0 0 80 104" aria-hidden="true">' +
      '<path d="M26 8 C24 20, 25 30, ' + (L + 2) + ' 40 M54 8 C56 20, 55 30, ' + (R - 2) + ' 40"/>' +
      '<path d="M30 8 C30 20, 29 30, 29 40 M50 8 C50 20, 51 30, 51 40"/>' +
      '<path class="rw-fq-shade" d="M' + (L + 2) + ' 40 L' + (R - 2) + ' 40 C' + (R + 1) + ' 52, ' + (R + 1) + ' 60, ' + (R - 2) + ' 64 L42 64 L40 60 L38 64 L' + (L + 2) + ' 64 C' + (L - 1) + ' 60, ' + (L - 1) + ' 52, ' + (L + 2) + ' 40 Z"/>' +
      '<path d="M' + (L + 2) + ' 40 L' + (R - 2) + ' 40 C' + (R + 1) + ' 52, ' + (R + 1) + ' 60, ' + (R - 2) + ' 64 M' + (L + 2) + ' 40 C' + (L - 1) + ' 52, ' + (L - 1) + ' 60, ' + (L + 2) + ' 64"/>' +
      '<path d="M' + (L + 2) + ' 64 L' + (L + 4) + ' 100 M' + (R - 2) + ' 64 L' + (R - 4) + ' 100 M40 66 L38 100 M40 66 L42 100"/>' +
      '<path class="rw-fq-dash" d="M' + (L - 4) + ' 44 C' + (L - 6) + ' 54, ' + (L - 6) + ' 62, ' + (L - 3) + ' 70 M' + (R + 4) + ' 44 C' + (R + 6) + ' 54, ' + (R + 6) + ' 62, ' + (R + 3) + ' 70"/>' +
      '</svg>';
  }

  var PANTS_TABLE = /*PANTS_TABLE*/{"flat|slim|slim":"vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv","flat|slim|regular":".vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv","flat|slim|loose":".............vvvvvvvvvvvvvvvvvvvvvvvvvvv.vvvvvvvvvv","flat|average|slim":"....vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv","flat|average|regular":"................vvvvvvvvvvvvvvvvvvvvvvvv....vvvvvvv","flat|average|loose":"...........................vvvvvvvvvvvvv...........","flat|wide|slim":"...................vvvvvvvvvvvvvvvvvvvvv.......vvvv","flat|wide|regular":"..............................vvvvvvvvvv...........","flat|wide|loose":"...................................................","average|slim|slim":"...vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv","average|slim|regular":"..............vvvvvvvvvvvvvvvvvvvvvvvvvv..vvvvvvvvv","average|slim|loose":"..........................vvvvvvvvvvvvvv...........","average|average|slim":".................vvvvvvvvvvvvvvvvvvvvvvv.....vvvvvv","average|average|regular":".............................vvvvvvvvvvv...........","average|average|loose":"...................................................","average|wide|slim":"................................vvvvvvvv...........","average|wide|regular":"...................................................","average|wide|loose":"...................................................","round|slim|slim":"................vvvvvvvvvvvvvvvvvvvvvvvv....vvvvvvv","round|slim|regular":"............................vvvvvvvvvvvv...........","round|slim|loose":"...................................................","round|average|slim":"...............................vvvvvvvvv...........","round|average|regular":"...................................................","round|average|loose":"...................................................","round|wide|slim":"...................................................","round|wide|regular":"...................................................","round|wide|loose":"..................................................."}/*END*/;

  function cmToFtIn(cm) {
    var inches = Math.round(cm / 2.54), ft = Math.floor(inches / 12), inch = inches % 12;
    return ft + ' ft ' + inch + ' in';
  }

  function Quiz(root) {
    this.root = root;
    var dataEl = root.querySelector('script[data-rw-fit-quiz]');
    this.data = JSON.parse(dataEl.textContent);
    this.sizes = this.data.sizes || [];
    this.garment = this.data.garment || 'item';
    this.fit = this.data.fit === 'relaxed' ? 'relaxed' : 'regular';
    this.kind = this.data.kind === 'bottom' ? 'bottom' : 'top';
    this.answers = {};
    this.step = 0;
    this.build();
    var self = this;
    this.trigger = root.querySelector('.rw-fq-trigger');
    this.trigger.addEventListener('click', function () { self.open(); }); /* like the original: a returning shopper re-runs the quiz from step 1 */
    this.profile = this.loadProfile();
    if (this.profile) { this.answers = this.profile; this.showReturning(); }
  }

  var PROFILE_KEY = 'rw-fit-quiz:profile';
  Quiz.prototype.loadProfile = function () {
    try { var p = JSON.parse(localStorage.getItem(PROFILE_KEY) || 'null'); return p && p.usual ? p : null; } catch (e) { return null; }
  };
  Quiz.prototype.saveProfile = function () {
    try { localStorage.setItem(PROFILE_KEY, JSON.stringify(this.answers)); } catch (e) {}
    this.profile = this.answers;
  };
  /* Returning shopper: the button becomes "We recommend size X" and the size is pre-selected, like the original. */
  Quiz.prototype.showReturning = function () {
    var rec = this.recommend();
    if (!rec) return;
    var label = this.trigger.querySelector('.rw-fq-label') || this.trigger.querySelector('span:last-child');
    label.textContent = 'We recommend size ' + rec.name;
    this.trigger.classList.add('rw-fq-trigger--returning');
    this.selectOnPage(rec.name);
  };
  Quiz.prototype.openResult = function () {
    this.answers = this.profile;
    this.renderResult();
    this.overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  };

  Quiz.prototype.steps = function () {
    var self = this;
    return [
      { key: 'usual', q: 'What ' + this.garment + ' size do you usually wear?', type: 'sizes' },
      { key: 'consistency', q: 'Do you always wear this size?', type: 'rows', options: [
        { v: 'smaller', label: 'No, I sometimes wear a smaller size' },
        { v: 'same', label: 'Yes' },
        { v: 'bigger', label: 'No, I sometimes wear a bigger size' }] },
      { key: 'belly', q: 'What do you think is most like you?', type: 'figures', figure: bellyFigure, options: [
        { v: 'flat', label: 'Flat' }, { v: 'average', label: 'Average' }, { v: 'round', label: 'Round' }] },
      this.kind === 'bottom'
        ? { key: 'hips', q: 'How would you describe your hips shape?', type: 'figures', figure: hipsFigure, options: [
            { v: 'slim', label: 'Slim' }, { v: 'average', label: 'Average' }, { v: 'wide', label: 'Wide' }] }
        : { key: 'chest', q: 'How would you describe your chest?', type: 'figures', figure: chestFigure, options: [
            { v: 'slim', label: 'Slim' }, { v: 'average', label: 'Average' }, { v: 'broad', label: 'Broad' }] },
      { key: 'height', q: 'How tall are you?', type: 'height' },
      { key: 'fit', q: 'What fit would you prefer for this item?', type: 'rows', options: [
        { v: 'slim', label: 'Slim fit' }, { v: 'regular', label: 'Regular fit' }, { v: 'loose', label: 'Loose fit' }] }
    ];
  };

  Quiz.prototype.build = function () {
    var self = this;
    var overlay = document.createElement('div');
    overlay.className = 'rw-fq-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Fit Quiz Size Advisor');
    overlay.innerHTML =
      '<div class="rw-fq-card">' +
        '<button type="button" class="rw-fq-icon rw-fq-back" aria-label="Back">' + ICON.back + '</button>' +
        '<button type="button" class="rw-fq-icon rw-fq-close" aria-label="Close">' + ICON.close + '</button>' +
        '<div class="rw-fq-body"></div>' +
        '<div class="rw-fq-help-text">Answer six quick questions and we will match you to a size from our own size chart for this item. Nothing is sent anywhere.</div>' +
        '<div class="rw-fq-footer">' +
          '<span class="rw-fq-step"></span>' +
          '<span class="rw-fq-powered">Powered by Rewind</span>' +
          '<span class="rw-fq-help"><button type="button" class="rw-fq-help-btn" aria-label="Help">?</button></span>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    this.overlay = overlay;
    this.body = overlay.querySelector('.rw-fq-body');
    this.stepEl = overlay.querySelector('.rw-fq-step');
    this.backBtn = overlay.querySelector('.rw-fq-back');
    overlay.querySelector('.rw-fq-close').addEventListener('click', function () { self.close(); });
    this.backBtn.addEventListener('click', function () { self.back(); });
    overlay.querySelector('.rw-fq-help-btn').addEventListener('click', function () {
      overlay.querySelector('.rw-fq-help-text').classList.toggle('is-open');
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) self.close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) self.close(); });
  };

  Quiz.prototype.open = function () {
    this.step = 0; this.answers = {};
    this.render();
    this.overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  };
  Quiz.prototype.close = function () {
    this.overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  };
  Quiz.prototype.back = function () { if (this.step > 0) { this.step--; this.render(); } };
  Quiz.prototype.next = function () {
    var steps = this.steps();
    if (this.step < steps.length - 1) { this.step++; this.render(); } else { this.renderResult(); }
  };

  Quiz.prototype.render = function () {
    var self = this, steps = this.steps(), s = steps[this.step], html = '';
    this.backBtn.hidden = this.step === 0;
    this.stepEl.textContent = (this.step + 1) + '/' + steps.length;
    this.overlay.querySelector('.rw-fq-help-text').classList.remove('is-open');
    html += '<div class="rw-fq-step-wrap"><p class="rw-fq-kicker">Take our Fit quiz</p><h2 class="rw-fq-question">' + s.q + '</h2>';
    if (s.type === 'sizes') {
      html += '<div class="rw-fq-options">' + this.sizes.map(function (sz) {
        return '<button type="button" class="rw-fq-opt rw-fq-opt--size' + (self.answers.usual === sz.name ? ' is-selected' : '') + '" data-v="' + sz.name + '">' + sz.name + '</button>';
      }).join('') + '</div>';
    } else if (s.type === 'rows') {
      html += '<div class="rw-fq-options">' + s.options.map(function (o) {
        return '<button type="button" class="rw-fq-opt rw-fq-opt--row' + (self.answers[s.key] === o.v ? ' is-selected' : '') + '" data-v="' + o.v + '">' + o.label + '</button>';
      }).join('') + '</div>';
    } else if (s.type === 'figures') {
      html += '<div class="rw-fq-options">' + s.options.map(function (o) {
        return '<button type="button" class="rw-fq-opt rw-fq-opt--figure' + (self.answers[s.key] === o.v ? ' is-selected' : '') + '" data-v="' + o.v + '">' + s.figure(o.v) + '<span>' + o.label + '</span></button>';
      }).join('') + '</div>';
    } else if (s.type === 'height') {
      var h = this.answers.height || 175;
      html += '<div class="rw-fq-height"><p class="rw-fq-height-ft">' + cmToFtIn(h) + '</p><p class="rw-fq-height-cm">' + h + ' cm</p>' +
        '<input type="range" class="rw-fq-range" min="140" max="210" step="1" value="' + h + '" aria-label="Height in centimetres">' +
        '<button type="button" class="rw-fq-btn rw-fq-next">Next</button></div>';
    }
    html += '</div>';
    this.body.innerHTML = html;

    var opts = this.body.querySelectorAll('.rw-fq-opt');
    Array.prototype.forEach.call(opts, function (b) {
      b.addEventListener('click', function () {
        self.answers[s.key] = b.getAttribute('data-v');
        Array.prototype.forEach.call(opts, function (x) { x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        setTimeout(function () { self.next(); }, 160);
      });
    });
    var range = this.body.querySelector('.rw-fq-range');
    if (range) {
      var ft = this.body.querySelector('.rw-fq-height-ft'), cm = this.body.querySelector('.rw-fq-height-cm');
      var paint = function () {
        var v = parseInt(range.value, 10);
        self.answers.height = v; ft.textContent = cmToFtIn(v); cm.textContent = v + ' cm';
        range.style.setProperty('--fill', ((v - 140) / 70 * 100) + '%');
      };
      paint();
      range.addEventListener('input', paint);
      this.body.querySelector('.rw-fq-next').addEventListener('click', function () { self.answers.height = parseInt(range.value, 10); self.next(); });
    }
  };

  /* The recommendation. Reproduces the behaviour measured from the Easysize Fit Quiz on this store
     (2,430 answer combinations replayed through its API on 26 Sep 2026, 100% match for the relaxed model,
     96% for the regular model with the only differences on knife-edge answers at exactly 175 cm).
     Score = belly (-1/0/+1) + 0.8 x chest (-1/0/+1) + fit (slim -0.25, regular 0, loose +1). Height does not matter.
     Regular fit (e.g. Executive): "sometimes smaller" -> one size down when score <= -0.7; otherwise one size up when score >= 0.7.
     Relaxed fit (e.g. Eternal):   "sometimes smaller" -> always one size down; otherwise one size down when score <= -0.7. Never up. */
  Quiz.prototype.recommend = function () {
    var a = this.answers, names = this.sizes.map(function (s) { return s.name; });
    var idx = names.indexOf(a.usual); if (idx < 0) return null;
    if (this.kind === 'bottom') {
      /* Bottoms (Como): measured from the original at every 1 cm of height, 150-200 cm, for all 27 belly/hips/fit answers.
         'v' = one size down at that height. "Sometimes smaller" is always one size down. Never up. */
      var shiftB = 0;
      if (a.consistency === 'smaller') { shiftB = -1; }
      else {
        var row = PANTS_TABLE[(a.belly || 'average') + '|' + (a.hips || 'average') + '|' + (a.fit || 'regular')] || '';
        var hh = Math.max(150, Math.min(200, Math.round(a.height || 175)));
        shiftB = row.charAt(hh - 150) === 'v' ? -1 : 0;
      }
      return this.sizes[Math.max(0, Math.min(names.length - 1, idx + shiftB))];
    }
    var score = ({ flat: -1, average: 0, round: 1 }[a.belly] || 0) + 0.8 * ({ slim: -1, average: 0, broad: 1 }[a.chest] || 0) + ({ slim: -0.25, regular: 0, loose: 1 }[a.fit] || 0);
    var shift = 0;
    if (this.fit === 'relaxed') {
      shift = (a.consistency === 'smaller' || score <= -0.7) ? -1 : 0;
    } else if (a.consistency === 'smaller') {
      shift = score <= -0.7 ? -1 : 0;
    } else {
      shift = score >= 0.7 ? 1 : 0;
    }
    var final = Math.max(0, Math.min(names.length - 1, idx + shift));
    return this.sizes[final];
  };

  Quiz.prototype.renderResult = function () {
    var self = this, rec = this.recommend();
    if (!rec) { this.answers = {}; this.step = 0; this.render(); return; }
    this.backBtn.hidden = true;
    this.stepEl.textContent = '';
    this.selectOnPage(rec.name);
    var html = '<div class="rw-fq-step-wrap"><p class="rw-fq-result-title">We have done the calculations and found your perfect fit!' +
      (rec.available ? '' : '<br>Unfortunately it is out of stock at the moment.') + '</p>' +
      '<p class="rw-fq-result-label">Your size</p><p class="rw-fq-result-size">' + rec.name + '</p>';
    if (rec.available) {
      html += '<button type="button" class="rw-fq-btn rw-fq-done">Continue with size ' + rec.name + '</button>';
    } else {
      html += '<button type="button" class="rw-fq-btn rw-fq-done">Return to your shopping</button>';
    }
    html += '<br><button type="button" class="rw-fq-link rw-fq-redo">Redo the quiz</button></div>';
    this.body.innerHTML = html;
    this.body.querySelector('.rw-fq-done').addEventListener('click', function () { self.close(); });
    this.body.querySelector('.rw-fq-redo').addEventListener('click', function () { self.answers = {}; self.open(); });
    this.saveProfile();
    this.showReturning();
  };

  /* Select the recommended size in the theme's own variant picker, so price, stock and the cart button update. */
  Quiz.prototype.selectOnPage = function (size) {
    var section = this.root.closest('.shopify-section, section, form') || document;
    /* Pack pages (Eternal 2/3-pack): no size option on the product itself. The pack picker has one colour + one size
       dropdown per item; fill every size dropdown with the recommended size, now and whenever a colour gets chosen later. */
    var pack = section.querySelector('[data-rw-set]') || document.querySelector('[data-rw-set]');
    if (pack) {
      this.packSize = size;
      var self = this;
      var applyPack = function () {
        Array.prototype.forEach.call(pack.querySelectorAll('.rw-bundle__item'), function (item) {
          var sel = item.querySelector('.rw-bundle__select--size');
          if (!sel || sel.disabled || sel.value) return;
          var opt = null;
          Array.prototype.forEach.call(sel.options, function (o) { if (!opt && !o.disabled && o.text.trim() === self.packSize) opt = o; });
          if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      };
      if (!pack.hasAttribute('data-rw-fq-hooked')) {
        pack.setAttribute('data-rw-fq-hooked', '1');
        pack.addEventListener('change', function (e) {
          if (e.target && e.target.classList.contains('rw-bundle__select--colour')) setTimeout(applyPack, 0);
        });
      }
      applyPack();
    }
    var inputs = section.querySelectorAll('input[type="radio"][data-option-name="Size" i], input[type="radio"][name^="Size" i]');
    var hit = null;
    Array.prototype.forEach.call(inputs, function (i) { if (!hit && i.value === size) hit = i; });
    if (!hit) {
      var sel = section.querySelector('select[name^="Size" i], select[data-option-name="Size" i]');
      if (sel) { sel.value = size; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    if (!hit.checked) { hit.click(); }
  };

  window.RwFitQuiz = Quiz;
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rw-fit-quiz-root]:not([data-ready])'), function (r) {
      r.setAttribute('data-ready', '1'); new Quiz(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
